import { inject } from '@angular/core';
import { RedirectCommand, type ResolveFn, Router } from '@angular/router';
import { type MaintenanceNotification, NotificationSyncStatusEnum } from '@mymaintenance/shared';
import { QueryClient } from '@tanstack/angular-query-experimental';
import { AppRoutes, appUrl } from '../../app.route.constants';
import { NotificationQueryService } from '../../shared/query/notification.queries';
import { TranslateService } from '../../shared/services/i18n.service';
import { NotificationsService } from '../../shared/services/notifications.service';

export const editableNoticeResolver: ResolveFn<MaintenanceNotification | RedirectCommand> = async (
  route,
) => {
  const queryClient = inject(QueryClient);
  const queries = inject(NotificationQueryService).queries;
  const notifications = inject(NotificationsService);
  const translate = inject(TranslateService);
  const router = inject(Router);

  const notice = await queryClient
    .fetchQuery({ ...queries.byId(route.paramMap.get('id') ?? ''), staleTime: 0 })
    .catch(() => null);
  if (notice?.SYNCSTATUS === NotificationSyncStatusEnum.PENDING) return notice;

  notifications.error(translate.getKeyTranslation('validateNotice.toasts.unavailable')());
  return new RedirectCommand(router.parseUrl(appUrl(AppRoutes.VALIDATE_NOTICE)), {
    replaceUrl: true,
  });
};
